module.exports = __webpack_public_path__ + "media/images/map/ligne17-a0feca33678c5d91a319467258ca976c.png";